import { render, staticRenderFns } from "./noBuyCode.vue?vue&type=template&id=40ca225a&"
import script from "./noBuyCode.vue?vue&type=script&lang=js&"
export * from "./noBuyCode.vue?vue&type=script&lang=js&"
import style0 from "./noBuyCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports